module.exports = __webpack_public_path__ + "static/media/Heart_OFF@3x.8d7dc4ff.png";